"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1266. 120 Casos d'Entrevista Policial (Ventes Sense Enviament)
    {
        hidden: true,
        id: 1266,
        tax: 0.04,
        created_at: "2026-08-26 00:00:08",
        start_at: "2025-08-26 00:00:08",
        sku: "iopos.book.120-casos-dentrevista-policial-3",
        name: "120 Casos d'Entrevista Policial",
        title: "120 Casos d'Entrevista Policial",
        description: "Prepara't per a les entrevistes policials amb 120 casos pràctics oficials. Aconsegueix la confiança i les eines necessàries per superar qualsevol repte!",
        enabled: true,
        stock: true,
        stock_message: "Estoc exhaurit!",
        type: product_types_1.Type.Other,
        category: [product_types_1.Category.Books, product_types_1.Category.GUB, product_types_1.Category.PL, product_types_1.Category.CP],
        price: 59.99,
        images: ["/561/image2"],
        banner: ["/561/image2"],
        shipment: 0,
        link: "/tienda/libros/120-casos-dentrevista-policial-compra-sense-enviament",
        more_info: true,
        can_be_sent: false,
        items: 1,
    },
    // 1267. Curs Semipresencial Homologat Dret Penal - 2026 (4 juliol)
    {
        id: 1267,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-11-octubre-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (11 octubre 2026)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (11 octubre 2026)",
        short: "6.) Curs Semipresencial Homologat Dret Penal (11 octubre 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3304],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v",
            landscape: "/1185/image1_h",
        },
        hero: {
            portrait: "/1185/hero_v",
            landscape: "/1185/hero_h",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
    },
    // 1268. Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (26/09 · 09-18h)
    {
        id: 1268,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-26-setembre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (26/09 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (26/09 · 09-18h)",
        short: "8.) Presencial de Psicos. Mossos 2026 (26/09 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2026-03-30 00:00:01",
        start_at: "2026-08-30 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1269. Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (02/10 · 09-18h)
    {
        id: 1269,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-02-octubre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (02/10 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (02/10 · 09-18h)",
        short: "9.) Presencial de Psicos. Mossos 2026 (02/10 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicºotecnics-aptitudinals-02-octubre-2026/",
        created_at: "2026-03-30 00:00:01",
        start_at: "2026-08-30 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1270. Simulacre Online Temari + Psicotècnics Mossos 2026 (12 octubre 2026)
    {
        id: 1270,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        sku: "iopos.course.online.simulacre-temari-psicotecnics-mossos-2026-12-octubre",
        title: "Simulacre Online Temari + Psicotècnics Mossos 2026 (12 octubre 2026)",
        name: "Simulacre Online Temari + Psicotècnics Mossos 2026 (12 octubre 2026)",
        description: "Posa’t a prova abans de l’examen, detecta els teus punts febles i arriba al 17 d’octubre sabent exactament en quin punt estàs.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 24.99,
        offer: 49.99,
        offer_message: "Sessió enregistrada.",
        offer_text: "Sessió enregistrada.",
        shipment: 0.0,
        images: ["/1270/image_h"],
        banner: ["/1270/image_h"],
        link: "/tienda/cursos/simulacre-online-temari-psicotecnics-mossos-2026-12-octubre/",
        created_at: "2026-09-17 00:00:01",
        start_at: "2026-09-17 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 1330, group_id: [3307] },
        productImage: {
            landscape: "/1270/image_h",
            portrait: "/1270/image_v",
        },
        hero: {
            firstTitle: "Simulacre Online Temari + Psicotècnics",
            secondTitle: "Mossos d'Esquadra 2026",
            thirdTitle: "**Posa’t a prova** abans de l’examen, **detecta els teus punts febles** i arriba al **17 d’octubre** sabent exactament en quin punt estàs.",
            landscape: "/1270/hero_h",
            portrait: "/1270/hero_v",
        },
    },
    // 1271. Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (26/09 · 09-18h)
    {
        id: 1271,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-6-octubre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (06/10 · 10-19h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (06/10 · 10-19h)",
        short: "10.) Presencial de Psicos. Mossos 2026 (06/10 · 10-19h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2026.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-6-octubre-2026/",
        created_at: "2026-09-01 00:00:01",
        start_at: "2026-10-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1272. Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (16/10 · 09-18h)
    {
        id: 1272,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-16-octubre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (16/10 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (16/10 · 09-18h)",
        short: "11.) Presencial de Psicos. Mossos 2026 (16/10 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2026.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-6-octubre-2026/",
        created_at: "2026-09-01 00:00:01",
        start_at: "2026-10-06 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1273. Curs Online Guàrdia Urbana de Barcelona (2026/2027)
    {
        id: 1273,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.curs-online-guardia-urbana-barcelona-2026-2027",
        title: "Curs Online Guàrdia Urbana de Barcelona (2026/2027)",
        name: "Curs Online Guàrdia Urbana de Barcelona (2026/2027)",
        category: [product_types_1.Category.GUB, product_types_1.Category.Online],
        description: "Prepara’t per a la Guàrdia Urbana de Barcelona 2026/2027 amb temari actualitzat, classes en directe, tests, psicotècnics i una tutora que t’acompanya fins a l’examen.",
        enabled: true,
        stock: true,
        stock_message: "Pròximament disponible!",
        price: 599.99,
        // offer: 599.99,
        // offer_message: "Oferta especial les 30 primeres matrícules!",
        // offer_text: "Oferta especial les 30 primeres matrícules!",
        shipment: 0.0,
        images: ["/1273/image_h"],
        banner: ["/1273/image_h"],
        link: "/tienda/cursos/curs-online-guardia-urbana-barcelona-2026-2027/",
        created_at: "2026-10-08 00:00:01",
        start_at: "2026-10-08 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: {
            course_id: 1333,
            group_id: [3310],
        },
        productImage: {
            portrait: "/1273/image_v",
            landscape: "/1273/image_h",
        },
        hero: {
            portrait: "/1273/hero_v",
            landscape: "/1273/hero_h",
            firstTitle: "Curs Online Guàrdia Urbana de Barcelona",
            secondTitle: "2026/2027",
            thirdTitle: "Prepara’t per aconseguir **la teva plaça a la Guàrdia Urbana de Barcelona** amb un **curs online complet**: temari actualitzat, classes en directe, psicotècnics, simulacres i **una tutora que t’acompanya fins a l’examen**.",
        },
    },
    // 1274. Pack Físiques Sant Adrià del Besòs - 8 Classes
    {
        id: 1274,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-sant-adria-15-clases",
        title: "Pack Físiques Sant Adrià del Besòs - 15 Classes",
        name: "Pack Físiques Sant Adrià del Besòs - 15 Classes",
        short: "Pack 15 Classes",
        description: "Potencia la teva preparació: un pack de físiques amb 15 classes dissenyades per a opositors compromesos a millorar el seu rendiment.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        // subtype: "Maximiza tus oportunidades: un pack de físicas con 5 clases que te ofrece una formación más completa y efectiva.",
        price: 129.99,
        discount_not_applicable: true,
        // price_text: "Gaudeix d'un 20 % de descompte",
        shipment: 0.0,
        images: ["/574/image5"],
        created_at: "2026-10-16 00:00:10",
        start_at: "2026-10-16 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 15,
        parent: 574,
        calendly: {
            uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", // prod
            // uuid: "0fd6cf4b-d9eb-4209-a9d0-3264391e17fa", // dev
            units: 15,
        },
        disallow_multiple_units: true,
    },
    // 1275. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet)
    {
        id: 1275,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet)",
        description: "Prepara el Biodata i les proves psicoprofessionals amb experts, descobreix els teus punts forts i afronta la tercera prova de Mossos amb confiança.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        hero: {
            firstTitle: "Curs Preparació Tercera Prova Mossos d'Esquadra 2027",
            secondTitle: "Presencial a l'Hospitalet",
            thirdTitle: "Prepara el **Biodata i les proves psicoprofessionals** amb experts, descobreix els teus punts forts i afronta la tercera prova de Mossos amb confiança.",
            landscape: "/1275/hero_h",
            portrait: "/1275/hero_v",
        },
        childs: [
            1277, 1278, 1279, 1280, 1281, 1282, 1283, 1284, 1285, 1286, 1287,
            1288, 1289, 1290, 1291, 1292, 1293, 1294, 1295, 1296, 1297, 1298,
            1299, 1300, 1301, 1302, 1303, 1304, 1310, 1311, 1312, 1313, 1314,
            1315,
        ],
    },
    // 1276. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona)
    {
        id: 1276,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona)",
        description: "La tercera prova no s'improvisa! Prepara el Biodata amb professionals, corregeix els teus errors i fes el primer pas cap al teu objectiu: ser Mosso d'Esquadra.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1276/image_h"],
        banner: ["/1276/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        // evolmind: { course_id: 0, group_id: [0] },
        productImage: {
            landscape: "/1276/image_h",
            portrait: "/1276/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027",
            secondTitle: "Ara a Tarragona!",
            thirdTitle: "La tercera prova no s'improvisa! **Prepara el Biodata** amb professionals, corregeix els teus errors i fes el primer pas cap al teu objectiu: **ser Mosso d'Esquadra**.",
            landscape: "/1276/hero_h",
            portrait: "/1276/hero_v",
        },
        childs: [1305, 1306, 1307, 1308],
    },
    // 1277. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 1)
    {
        id: 1277,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g1",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 1 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 1 - Matí)",
        short: "Grup 1) Preparació Tercera Prova Mossos d'Esquadra 2027 (28/11/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        // offer: 49.99,
        // offer_message: "Sessió enregistrada.",
        // offer_text: "Sessió enregistrada.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3337] },
    },
    // 1278. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 2)
    {
        id: 1278,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g2",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 2 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 2 - Tarda)",
        short: "Grup 2) Preparació Tercera Prova Mossos d'Esquadra 2027 (28/11/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3340] },
    },
    // 1279. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 3)
    {
        id: 1279,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g3",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 3 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 3 - Matí)",
        short: "Grup 3) Preparació Tercera Prova Mossos d'Esquadra 2027 (29/11/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3343] },
    },
    // 1280. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 4)
    {
        id: 1280,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g4",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 4 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 4 - Tarda)",
        short: "Grup 4) Preparació Tercera Prova Mossos d'Esquadra 2027 (29/11/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3346] },
    },
    // 1281. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 5)
    {
        id: 1281,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g5",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 5 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 5 - Matí)",
        short: "Grup 5) Preparació Tercera Prova Mossos d'Esquadra 2027 (05/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3349] },
    },
    // 1282. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 6)
    {
        id: 1282,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g6",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 6 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 6 - Tarda)",
        short: "Grup 6) Preparació Tercera Prova Mossos d'Esquadra 2027 (05/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3352] },
    },
    // 1283. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 7)
    {
        id: 1283,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g7",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 7 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 7 - Matí)",
        short: "Grup 7) Preparació Tercera Prova Mossos d'Esquadra 2027 (06/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3355] },
    },
    // 1284. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 8)
    {
        id: 1284,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g8",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 8 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 8 - Tarda)",
        short: "Grup 8) Preparació Tercera Prova Mossos d'Esquadra 2027 (06/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3358] },
    },
    // 1285. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 9)
    {
        id: 1285,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g9",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 9 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 9 - Matí)",
        short: "Grup 9) Preparació Tercera Prova Mossos d'Esquadra 2027 (09/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3361] },
    },
    // 1286. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 10)
    {
        id: 1286,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g10",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 10 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 10 - Tarda)",
        short: "Grup 10) Preparació Tercera Prova Mossos d'Esquadra 2027 (09/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3364] },
    },
    // 1287. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 11)
    {
        id: 1287,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g11",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 11 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 11 - Matí)",
        short: "Grup 11) Preparació Tercera Prova Mossos d'Esquadra 2027 (12/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3367] },
    },
    // 1288. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 12)
    {
        id: 1288,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g12",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 12 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 12 - Tarda)",
        short: "Grup 12) Preparació Tercera Prova Mossos d'Esquadra 2027 (12/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3370] },
    },
    // 1289. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 13)
    {
        id: 1289,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g13",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 13 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 13 - Matí)",
        short: "Grup 13) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3373] },
    },
    // 1290. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 14)
    {
        id: 1290,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g14",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 14 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 14 - Tarda)",
        short: "Grup 14) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3376] },
    },
    // 1291. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 17)
    {
        id: 1291,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g17",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 17 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 17 - Matí)",
        short: "Grup 17) Preparació Tercera Prova Mossos d'Esquadra 2027 (15/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3385] },
    },
    // 1292. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 18)
    {
        id: 1292,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g18",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 18 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 18 - Tarda)",
        short: "Grup 18) Preparació Tercera Prova Mossos d'Esquadra 2027 (15/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3388] },
    },
    // 1293. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 19)
    {
        id: 1293,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g19",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 19 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 19 - Matí)",
        short: "Grup 19) Preparació Tercera Prova Mossos d'Esquadra 2027 (19/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3391] },
    },
    // 1294. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 20)
    {
        id: 1294,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g20",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 20 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 20 - Tarda)",
        short: "Grup 20) Preparació Tercera Prova Mossos d'Esquadra 2027 (19/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3394] },
    },
    // 1295. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 21)
    {
        id: 1295,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g21",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 21 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 21 - Matí)",
        short: "Grup 21) Preparació Tercera Prova Mossos d'Esquadra 2027 (20/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3397] },
    },
    // 1296. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 22)
    {
        id: 1296,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g22",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 22 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 22 - Tarda)",
        short: "Grup 22) Preparació Tercera Prova Mossos d'Esquadra 2027 (20/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3400] },
    },
    // 1297. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 23)
    {
        id: 1297,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g23",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 23 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 23 - Matí)",
        short: "Grup 23) Preparació Tercera Prova Mossos d'Esquadra 2027 (29/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3403] },
    },
    // 1298. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 24)
    {
        id: 1298,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g24",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 24 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 24 - Tarda)",
        short: "Grup 24) Preparació Tercera Prova Mossos d'Esquadra 2027 (29/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3406] },
    },
    // 1299. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 25)
    {
        id: 1299,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g25",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 25 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 25 - Matí)",
        short: "Grup 25) Preparació Tercera Prova Mossos d'Esquadra 2027 (02/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3409] },
    },
    // 1300. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 26)
    {
        id: 1300,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g26",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 26 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 26 - Tarda)",
        short: "Grup 26) Preparació Tercera Prova Mossos d'Esquadra 2027 (02/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3412] },
    },
    // 1301. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 27)
    {
        id: 1301,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g27",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 27 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 27 - Matí)",
        short: "Grup 27) Preparació Tercera Prova Mossos d'Esquadra 2027 (03/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3415] },
    },
    // 1302. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 28)
    {
        id: 1302,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g28",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 28 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 28 - Tarda)",
        short: "Grup 28) Preparació Tercera Prova Mossos d'Esquadra 2027 (03/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3418] },
    },
    // 1303. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 31)
    {
        id: 1303,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g31",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 31 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 31 - Matí)",
        short: "Grup 31) Preparació Tercera Prova Mossos d'Esquadra 2027 (07/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3427] },
    },
    // 1304. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 32)
    {
        id: 1304,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g32",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 32 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 32 - Tarda)",
        short: "Grup 32) Preparació Tercera Prova Mossos d'Esquadra 2027 (07/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3430] },
    },
    // 1305. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 15)
    {
        id: 1305,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona-g15",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 15 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 15 - Matí)",
        short: "Grup 15) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/12/2026 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a Tarragona.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1276/image_h"],
        banner: ["/1276/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1276/image_h",
            portrait: "/1276/image_v",
        },
        parent: 1276,
        evolmind: { course_id: 1354, group_id: [3379] },
    },
    // 1306. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 16)
    {
        id: 1306,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona-g16",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 16 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 16 - Tarda)",
        short: "Grup 16) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/12/2026 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a Tarragona.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1276/image_h"],
        banner: ["/1276/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1276/image_h",
            portrait: "/1276/image_v",
        },
        parent: 1276,
        evolmind: { course_id: 1354, group_id: [3382] },
    },
    // 1307. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 29)
    {
        id: 1307,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona-g29",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 29 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 29 - Matí)",
        short: "Grup 29) Preparació Tercera Prova Mossos d'Esquadra 2027 (03/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a Tarragona.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1276/image_h"],
        banner: ["/1276/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1276/image_h",
            portrait: "/1276/image_v",
        },
        parent: 1276,
        evolmind: { course_id: 1354, group_id: [3421] },
    },
    // 1308. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 30)
    {
        id: 1308,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona-g30",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 30 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Tarragona - Grup 30 - Tarda)",
        short: "Grup 30) Preparació Tercera Prova Mossos d'Esquadra 2027 (03/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a Tarragona.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1276/image_h"],
        banner: ["/1276/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-tarragona/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1276/image_h",
            portrait: "/1276/image_v",
        },
        parent: 1276,
        evolmind: { course_id: 1354, group_id: [3424] },
    },
    // 1309. Pack Físiques Torredembarra Apolo - 15 Classes
    {
        id: 1309,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisicas-torredembarra-apolo-15-clases",
        title: "Pack Físiques Torredembarra Apolo - 15 Classes",
        name: "Pack Físiques Torredembarra Apolo - 15 Classes",
        short: "Pack 15 Classes",
        description: "Maximiza tus oportunidades: un pack de físicas con 15 clases que te ofrece una formación más completa y efectiva.",
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        price: 129.99,
        discount_not_applicable: true,
        shipment: 0.0,
        images: ["/579/image4"],
        created_at: "2024-06-28 00:00:10",
        start_at: "2024-06-28 00:00:10",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 15,
        parent: 579,
        default_in_parent: false,
        calendly: {
            uuid: "a07ad2ef-98f7-4145-9dc7-14fb6cbe2de5", // prod
            // uuid: "df603638-ce27-4518-b1fe-b9b63e23c806", // dev
            units: 15,
        },
        disallow_multiple_units: true,
    },
    // 1310. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 33)
    {
        id: 1310,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g33",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 33 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 33 - Matí)",
        short: "Grup 33) Preparació Tercera Prova Mossos d'Esquadra 2027 (09/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3433] },
    },
    // 1311. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 34)
    {
        id: 1311,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g34",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 34 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 34 - Tarda)",
        short: "Grup 34) Preparació Tercera Prova Mossos d'Esquadra 2027 (09/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3436] },
    },
    // 1312. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 35)
    {
        id: 1312,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g35",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 35 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 35 - Matí)",
        short: "Grup 35) Preparació Tercera Prova Mossos d'Esquadra 2027 (10/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3439] },
    },
    // 1313. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 36)
    {
        id: 1313,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g36",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 36 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 36 - Tarda)",
        short: "Grup 36) Preparació Tercera Prova Mossos d'Esquadra 2027 (10/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3442] },
    },
    // 1314. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 37)
    {
        id: 1314,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g37",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 37 - Matí)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 37 - Matí)",
        short: "Grup 37) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/01/2027 - Matí)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3445] },
    },
    // 1315. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 38)
    {
        id: 1315,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet-g38",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 38 - Tarda)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2027 (Hospitalet - Grup 38 - Tarda)",
        short: "Grup 38) Preparació Tercera Prova Mossos d'Esquadra 2027 (13/01/2027 - Tarda)",
        description: "Prepara't per a la tercera prova dels Mossos d'Esquadra 2027 amb aquest curs presencial a l'Hospitalet.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        // offer: 129.99,
        // offer_message: "Oferta les 100 primeres matrícules.",
        // offer_text: "Oferta les 100 primeres matrícules.",
        shipment: 0.0,
        images: ["/1275/image_h"],
        banner: ["/1275/image_h"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-d-esquadra-2027-hospitalet/",
        created_at: "2026-10-19 00:00:01",
        start_at: "2026-10-19 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        productImage: {
            landscape: "/1275/image_h",
            portrait: "/1275/image_v",
        },
        parent: 1275,
        evolmind: { course_id: 1354, group_id: [3448] },
    },
];
exports.default = products;
